export enum ReactedWithEnum {
  FIRE = 'FIRE',
  HEART = 'HEART',
  THUMBS_UP = 'THUMBS_UP',
  FACE_SURPRISE = 'FACE_SURPRISE',
  FACE_LAUGH = 'FACE_LAUGH',
  CUSTOM = 'CUSTOM',
}
